import { isBetween } from "@utils";
import { CollisionPriority, CollisionType } from "@dnd-kit/abstract";

export const timelineCollisionDetection = ({dragOperation, droppable}) => {
  if (!droppable.shape || !dragOperation.shape) return null;

  const distance = dragOperation.shape.current.left - droppable.shape.left;
  let weight = 1/(Math.abs(distance)/4) + (distance > 0 ? 10 : 0);

  if(isBetween(
    dragOperation.shape.current.left,
    droppable.shape.left,
    droppable.shape.left + droppable.shape.width
  ))
    weight = 200;

  return {
    id: droppable.id,
    value: weight,
    type: CollisionType.Collision,
    priority: CollisionPriority.Highest,
  };

  // return null;
}